

































































































































import {ClosingModel, PredicateDefinition, QueryOperator, SortOrder, WorkTaskStatementModel} from '@/libs/Api';
import Page from '@/Page.vue';
import {Component, Prop, Ref} from 'vue-property-decorator';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {CrudAction} from '@/libs/core/+state/models/crud-action';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {workTaskStatementsStore} from '@/libs/work-task-statements/+state/store';
import StatementDetailDialog from "@/libs/statements/components/StatementDetailDialog.vue";
import moment from "moment/moment";
import ApiService from "@/libs/core/api-service";

@Component({
	components: {StatementDetailDialog}
})
export default class ClosingDialog extends Page {

    private dialog = false;
	private partyId: string | null = null;
	private predicates: PredicateDefinition[] = [];
	private headers = [
		{ text: "Datum", value: "workTask.time", align: "left", width: "10%" },
		{ text: "Pečovatel", value: "user.lastName", align: "left", width: "10%" },
		{ text: "Úkon", value: "workTask.catalogueItem.name", align: "left" },
		{ text: "Cena za jednotku", value: "workTask.unitPrice", align: "left", width: "10%" },
		{ text: "Množství", value: "amount", align: "left", width: "10%" },
		{ text: "Návštěva", value: "visitNumber", align: "left", width: "10%" },
		{ text: "Cena", value: "price", align: "left", width: "10%" },
		{ text: "", value: "id", align: "left", width: "10%" },
	];
	makingClosingModel = false;
	confirmDialog = false;

	@Ref() statementDialog!: StatementDetailDialog;

    open (partyId: string, predicates: PredicateDefinition[]) {
        this.dialog = true;
        this.partyId = partyId;
        this.predicates = predicates;
		this.loadStatements();
    }

	get workTaskStatements(): WorkTaskStatementModel[] {
		return workTaskStatementsStore.useGetter(CrudGetter.Data, "ClosingDialog");
	}

	get loading(): boolean {
		return workTaskStatementsStore.useGetter(CrudGetter.Pending, "ClosingDialog");
	}

	getPredicates() {
		let predicates = [...this.predicates ?? []] as any;
		predicates = [
			...predicates,
			...[
				{ field: "billingId", op: QueryOperator.Eq, comparand: null },
				{ field: "workTask.partyWorkDay.partyId", op: QueryOperator.Eq, comparand: this.partyId }
			]
		];
		return predicates;
	}

	loadStatements() {
		workTaskStatementsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskStatementModel>([
			{ field: "workTask.time", index: 1, order: SortOrder.Asc },
			{ field: "workTask.catalogueItem.name", index: 2, order: SortOrder.Asc }
		], this.getPredicates(), undefined, false, "ClosingDialog"));
	}

    close () {
			this.dialog = false;
    }

	openStatement (item: WorkTaskStatementModel) {
		this.statementDialog.open(item.id!);
	}

	loadSum() {
		console.log("loadSum");
	}

	makeClosingOfClientClick() {
		this.confirmDialog = true;
	}

	makeClosingOfClient() {
		this.confirmDialog = false;
		this.makingClosingModel = true;
		ApiService.api.makeClosingBatch({
			predicates: this.getPredicates(),
			orderby: []
		}).then(() => {
			this.makingClosingModel = false;
			this.$emit("change");
			this.close();
		}).catch(() => {
			this.makingClosingModel = false;
		});
	}

}
